module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/168-bulgaria-37070f78452a224919bb17672bfd5970.svg";